// extracted by mini-css-extract-plugin
export default {"StarsResult_Element":"StarsResult_StarsResult_Element__Y2m6t"};